import { assetsDomain } from '../utils';

export const color = {
	black: '#000000',
	dark: '#10151c',
	white: '#ffffff',
	gray: '#969696',
	semiLightGray: '#ddd9d3',
	lightGray: '#fafafa',
	darkGray: '#323232',
	fbBlue: '#4065b4',
	darkBlue: '#002e56',
	blue: '#0059b5',
	lightBlue: '#0076ff',
	pickledBluewood: '#2c394c',
	cobaltBlue: '#19202a',
	cobaltBlueLight: '#282f38',
	orange: '#ff7800',
	darkPurple: '#061751',
	fsBlue: '#002e56',
};

export const fontWeight = {
	bolder: 900,
	bold: 700,
	semibold: 500,
	normal: 300,
	light: 200,
};

export const iconUrl = {
	facebook: `${assetsDomain}images/facebook.svg`,
	facebookShare: `${assetsDomain}images/ic-share-fb.svg`,
	icPlayTiny: `${assetsDomain}images/ic-play-tiny.svg`,
	icPlayMed: `${assetsDomain}images/ic-play-med.svg`,
	upNext: `${assetsDomain}images/ic-upNext.png`,
	closeIconWhite: `${assetsDomain}images/ic-close-white.svg`,
	fsWhite: `${assetsDomain}images/ic-fs-white@2x.png`,
	icLive: `${assetsDomain}images/ic-live@2x.png`,
	fsgoWhite: `${assetsDomain}images/FoxSportsGO-white.svg`,
	fsgoBlack: `${assetsDomain}images/FoxSportsGO.svg`,
	icKey: `${assetsDomain}images/ic-key.svg`,
	lock: `${assetsDomain}images/lock.svg`,
	fsApp: `${assetsDomain}images/FoxSports_AppIcon.svg`,
	fsAppDark: `${assetsDomain}images/FoxSports_AppIcon_Dark.svg`,
	icFbWhite: `${assetsDomain}images/facebook-ico.png`,
	icFBShareSmall: `${assetsDomain}images/ic-fbsmall.png`,
	icFBShareBig: `${assetsDomain}images/ic-fbbig.png`,
	icUrlLink: `${assetsDomain}images/ic-link-share.png`,
	icUrlLinkIcon: `${assetsDomain}images/ic-url-link.svg`,
	icEmail: `${assetsDomain}images/ic-email-share.png`,
	icEmailIcon: `${assetsDomain}images/ic-email.svg`,
	icWhatsapp:  `${assetsDomain}images/ic-whatsapp.png`,
	icSms:  `${assetsDomain}images/ic-sms.png`,
	icLatestEpisode: `${assetsDomain}images/ic-latest-episode@2x.png`,
	icExplicit: `${assetsDomain}images/ic-explicit@2x.png`,
	icExplicitLarge: `${assetsDomain}images/ic-explicit-large@2x.png`,
	icLoading: `${assetsDomain}images/throbber.png`,
	icCheckMark: `${assetsDomain}images/tick.svg`,
};
